import React from 'react';
import configuration from '../../utils/config.js';

const FullClientLogo = ({ record, translate }) => (
	<div>
        <img src={configuration.logos + 'clients/logo_' + record.id + '.png'} alt="" />
	</div>
);

export default  FullClientLogo ;
